import { StrictMode, useEffect } from 'react';

import App from '@/App';
import '@/styles/globals.css';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled:
    import.meta.env.PROD || import.meta.env.VITE_ENABLE_SENTRY === 'true',
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  profilesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [/^\/api\//],
});

// Show legacy JuttAI branding on jutt* domains, new branding otherwise.
// Lives here (bundled module) rather than an inline <head> script because the
// backend CSP blocks inline scripts (scriptSrc has no 'unsafe-inline').
if (/jutt/i.test(window.location.hostname)) {
  document.title = 'JuttAI';
  document
    .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
    .forEach((el) => el.parentNode?.removeChild(el));
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = '/favicon-jutt.ico?v=jutt';
  document.head.appendChild(link);
}

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
